import React from 'react';
import {
  AutocompleteInput,
  BooleanInput,
  Edit,
  NumberInput,
  ReferenceInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
} from 'react-admin';
import { isIreland } from '../../../../helpers/appTypeHelper';

const GamesEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const GamesEdit = (props) => (
  <Edit undoable={false} {...props}>
    <SimpleForm toolbar={<GamesEditToolbar />}>
      <NumberInput label="ID" source="id" disabled />
      <TextInput label="Name" source="name" validate={required()} />
      <TextInput label="URL" source="url" validate={required()} />
      <ReferenceInput
        source="article_id"
        label="Related Article"
        allowEmpty
        reference={`admin/knowledge-bank/articles/autocomplete`}
        perPage={10000}
      >
        <AutocompleteInput />
      </ReferenceInput>
      {isIreland() && (
        <BooleanInput style={{ width: '300px' }} label="Included in the Progress bar" source="progress_bar_enable" />
      )}
    </SimpleForm>
  </Edit>
);

export default GamesEdit;
